import { render, staticRenderFns } from "./DispatchMassMessage.vue?vue&type=template&id=023c64d5&scoped=true&"
import script from "./DispatchMassMessage.vue?vue&type=script&lang=js&"
export * from "./DispatchMassMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c64d5",
  null
  
)

export default component.exports